import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { getIdentityActiveRoleName } from 'store/entities/identity/selectors'
import { sendError } from 'store/entities/analytics/actions'
import { fetchCountriesCodes } from 'store/entities/localSettings/actions'
import AsyncRouter from './AsyncRouter'

const mapStateToProps = state => ({
  role: getIdentityActiveRoleName(state),
})

const mapDispatchToProps = {
  sendError,
  fetchCountriesCodes,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AsyncRouter))
